<template>
  <div name="max" class="">

    <div class="w-95p mx-auto pb-10 grid md:grid-cols-2 grid-cols-1 space-x-6 ">
      <div class=" w-11/12 mx-auto" >
        <h2 class="text-base font-bold mb-4">Documents</h2>

        <ResourceList  :hasAccess="hasMaxWhitlockAccess"  :type="typeSelected"></ResourceList>
      </div>

      <div class=" w-11/12 mx-auto" >
        <h2 class="text-base font-bold mb-4">Videos</h2>
        <VideoList   :hasAccess="hasMaxWhitlockAccess"  :type="typeSelected"></VideoList>
      </div>
      </div>
   
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const ResourceList = () => import("@/components/library/TheResourceList.vue");
const VideoList = () => import("@/components/library/TheVideoList.vue");


export default {
  name: "max",
  props: [],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    hasMaxWhitlockAccess() {
      return this.currentAccess.maxWhitlockAccess
    },
  },
  data() {
    return {
      typeSelected: null,
    };
  },
  created() {
    this.typeSelected = { value: "maxw_extra" , name: "maxw_extra"  }
  },
  mounted() {},
  methods: {},
  components: {
    ResourceList,
    VideoList
  },
};
</script>

<style scoped>
</style>